var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAvatarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 19.708 23.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_567",
    "data-name": "\\u7EC4 567",
    transform: "translate(-2139.292 -1550.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_247",
    "data-name": "\\u8DEF\\u5F84 247",
    d: "M2142.936,1574c-.268-.056-.541-.1-.8-.171a3.7,3.7,0,0,1-2.824-3.542,12.608,12.608,0,0,1,.818-5.338,4.9,4.9,0,0,1,2.19-2.644,4.319,4.319,0,0,1,2.15-.516,1.652,1.652,0,0,1,.707.244c.35.19.675.427,1.015.637a5.252,5.252,0,0,0,5.931-.005c.274-.17.554-.334.812-.527a1.97,1.97,0,0,1,1.555-.316,4.379,4.379,0,0,1,3.346,2.405,9.868,9.868,0,0,1,1.076,3.834,19.078,19.078,0,0,1,.091,2.072,3.781,3.781,0,0,1-3.492,3.824.824.824,0,0,0-.15.043Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_248",
    "data-name": "\\u8DEF\\u5F84 248",
    d: "M2148.992,1561.748a5.7,5.7,0,1,1,5.705-5.68A5.687,5.687,0,0,1,2148.992,1561.748Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatarFilled);
export default __webpack_public_path__ + "static/media/user_avatar_filled.75a9ecc5e81a5b3ba7a057b7bf85de93.svg";
export { ForwardRef as ReactComponent };